import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { styled } from '@mui/material/styles';

// Colors for brand identity
const MAIN_BLUE = '#2b5baa';

// Responsive wrapper
const Wrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  minWidth: 80,
  maxWidth: 120,
  height: 40,
  background: 'transparent',
  border: `2px solid ${MAIN_BLUE}`,
  borderRadius: 20,
  overflow: 'hidden',
  transition: 'all 0.3s ease',
  '&:hover': {
    background: `linear-gradient(135deg, ${MAIN_BLUE}10, `,
  },
  [theme.breakpoints.down('lg')]: {
    minWidth: 70,
    maxWidth: 100,
    height: 36,
  },
  [theme.breakpoints.down('sm')]: {
    minWidth: 60,
    maxWidth: 90,
    height: 32,
    borderRadius: 16,
  },
}));

const CustomSelect = styled(Select)(({ theme }) => ({
  width: '100%',
  height: '100%',
  backgroundColor: 'transparent',
  color: MAIN_BLUE,
  fontWeight: 600,
  fontSize: 14,
  paddingLeft: 12, // fixed (no icon anymore)
  paddingRight: 8,
  border: 'none',
  cursor: 'pointer',
  '& .MuiSelect-select': {
    padding: '8px 12px !important', // tightened padding
    display: 'flex',
    alignItems: 'center',
    minHeight: 'auto',
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  '& .MuiSelect-icon': {
    color: MAIN_BLUE,
    right: 4,
    fontSize: 18,
    transition: 'all 0.2s ease',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '&:hover:not(.Mui-disabled)': {
    backgroundColor: 'transparent',
   
  },
  '&.Mui-focused': {
    backgroundColor: 'transparent',
    
  },
  [theme.breakpoints.down('lg')]: {
    fontSize: 13,
    paddingLeft: 10,
    '& .MuiSelect-select': {
      padding: '6px 10px !important',
    },
    '& .MuiSelect-icon': {
      fontSize: 16,
    },
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 12,
    paddingLeft: 8,
    '& .MuiSelect-select': {
      padding: '5px 8px !important',
    },
    '& .MuiSelect-icon': {
      fontSize: 14,
      right: 2,
    },
  },
}));

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  color: MAIN_BLUE,
  fontWeight: 500,
  fontSize: 14,
  padding: '8px 16px',
  minHeight: 'auto',
  transition: 'all 0.2s ease',
  '&.Mui-selected': {
    backgroundColor: `${MAIN_BLUE}15`,
    color: MAIN_BLUE,
    fontWeight: 600,
   
  },
  
  [theme.breakpoints.down('sm')]: {
    fontSize: 13,
    padding: '6px 12px',
  },
}));

const LanguageSelector = () => {
  const { currentLanguage, setLanguage } = useLanguage();

  const handleChange = (event) => {
    setLanguage(event.target.value);
  };

  const getLanguageDisplay = (lang) => {
    switch (lang) {
      case 'en': return 'EN';
      case 'fr': return 'FR';
      default: return 'EN';
    }
  };

  return (
    <Wrapper>
      <CustomSelect
        id="language-select"
        value={currentLanguage || 'en'}
        onChange={handleChange}
        variant="outlined"
        size="small"
        renderValue={(value) => getLanguageDisplay(value)}
        MenuProps={{
          PaperProps: {
            style: {
              borderRadius: 12,
              minWidth: 120,
              maxHeight: 200,
              marginTop: 4,
              boxShadow: '0 4px 20px rgba(43,91,170,0.15)',
              border: `1px solid ${MAIN_BLUE}20`,
            },
          },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
        }}
      >
        <CustomMenuItem value="en">
          <span style={{ marginRight: 8 }}>🇺🇸</span>
          English
        </CustomMenuItem>
        <CustomMenuItem value="fr">
          <span style={{ marginRight: 8 }}>🇫🇷</span>
          Français
        </CustomMenuItem>
      
      </CustomSelect>
    </Wrapper>
  );
};

export default LanguageSelector;
